import React, { useEffect } from "react";
import { Table, Tag, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { usePurchasePoModel } from "../purchasePoModel";
import { IPurchasePoDetail } from "../purchasePoType"
import { useDictModel } from "../../../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import YhTag from "@/components/YhTag";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

type statusType = {
    "purchase.create": string,
    "purchase.completely-io": string,
    "purchase.settle": string,
    "purchase.change": string,
    [key: string]: any
}

export function DataTable() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { dataSource, selectedRowKeys, pgCfg, descRows, loadData, setSelectedRowKeys, setDescRows } = usePurchasePoModel();
    const { getTreeNodeName, getTreeNodeOne } = useDictModel();
    const statusColor: statusType = {
        "purchase.create": "blue",
        "purchase.completely-io": "cyan",
        "purchase.settle": "green",
        "purchase.change": "red",
    }
    const columns: ColumnsType<IPurchasePoDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            render: (text, record, index) => `${index + 1}`
        }, {
            // title: '采购单号',
            title: Locale["Purchase Doc No."],
            dataIndex: 'purchaseCode',
            width: 180,
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '单据状态',
            title: Locale["Status"],
            width: 120,
            dataIndex: 'status',
            ellipsis: true,
            // render: (text) => <YhTag color={statusColor[getTreeNodeName(text)]} text={getTreeNodeName(text)} />,
            render: (text) => <YhTag color={statusColor[text]} text={language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string} />,
        }, {
            // title: '支付状态',
            title: Locale["Payment status"],
            width: 160,
            dataIndex: 'payStatus',
            render: (text) => getTreeNodeName(text)

        }, {
            // title: '单据日期',
            title: Locale["Creation Time"],
            dataIndex: 'createTime',
            width: 170,
        }, {
            // title: '供应商名称',
            title: Locale["Supplier Name"],
            width: 120,
            dataIndex: 'supplierName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '联系人',
            title: Locale["Contact"],
            width: 120,
            dataIndex: 'contact',
        }, {
            // title: '联系电话',
            title: Locale["Contact Number"],
            width: 140,
            dataIndex: 'phone',
        }, {
            // title: '采购数量',
            title: Locale["Purchase Qty"],
            width: 120,
            dataIndex: 'totalNum',
        }, {
            // title: '采购金额',
            title: Locale["Purchase Amount"],
            width: 120,
            dataIndex: 'totalAmount',
        }, {
            // title: '应付金额',
            title: Locale["Payable Amount"],
            width: 120,
            dataIndex: 'totalAmount',
        }, {
            // title: '已付金额',
            title: Locale["Paid Amount"],
            width: 120,
            dataIndex: 'amountReceived',
        }, {
            // title: '制单员',
            title: Locale["Creator"],
            width: 120,
            dataIndex: 'createUser',
        }, {
            // title: '库管员',
            title: Locale["Storekeeper"],
            width: 120,
            dataIndex: 'storekeeper',
        }, {
            // title: '入库时间',
            title: Locale["Stock-in Time"],
            width: 180,
            dataIndex: 'stockIoTime',
        }, {
            // title: '结算类型',
            title: Locale["Payment Type"],
            width: 160,
            dataIndex: 'payType',
            // render: (text) => getTreeNodeName(text)
            render: (text) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0]?.name : getTreeNodeOne(text)[0]?.nameEn as string
                } else {
                    return ""
                }
            }
        }, {
            // title: '结算员',
            title: Locale["Reckoner"],
            width: 120,
            dataIndex: 'reckoner',
        }, {
            // title: '结算时间',
            title: Locale["Settle Time"],
            width: 120,
            dataIndex: 'settleTime',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
            // }, {
            //     title: '打印次数(暂无)',
            //     width: 120,
            //     dataIndex: 'fax',
        }, {
            // title: '核销时间',
            title: Locale["Write off time"],
            width: 180,
            ellipsis: true,
            dataIndex: 'payTime',
        }, {
            // title: '备注',
            title: Locale["Note"],
            width: 120,
            dataIndex: 'note',
        }
    ];


    useEffect(() => {
        loadData()
    }, [])

    //点击行选高亮
    const onRow = (record: IPurchasePoDetail) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    return (
        <Table
            style={{ cursor: "pointer" }}
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: IPurchasePoDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => {
                return {
                    onClick: () => onRow(record)
                };
            }}
            scroll={{ x: 'max-content', y: 460 }}
        />
    )
}
